export const INPUT_TYPE_OPTIONS=[
    { label: "Text", value: "text" },
    { label: "Select", value: "select"},
    { label: "Radio", value: "radio"}
]